'use strict';
var $export = require('./_export');
var $re = require('./_replacer')(/[&<>"']/g, {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&apos;'
});

$export($export.P + $export.F, 'String', { escapeHTML: function escapeHTML() { return $re(this); } });



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/core.string.escape-html.js
// module id = 1008
// module chunks = 0